import { AutocompleteOptionDirective } from './autocomplete-option.directive';
import { AutocompleteOriginDirective } from './autocomplete-origin.directive';
import { AutocompleteTriggerDirective } from './autocomplete-trigger.directive';
import { AutocompleteComponent } from './autocomplete.component';

export const AutocompleteImports = [
  AutocompleteComponent,
  AutocompleteOptionDirective,
  AutocompleteOriginDirective,
  AutocompleteTriggerDirective,
];
